import { ReactNode } from 'react';
import { Tooltip } from '@mantine/core';

import { DISABLED_TOOLTIP_DELAY } from './constants';

type DisabledReasonTooltipProps = {
  label?: ReactNode;
  disabled?: boolean;
  children?: ReactNode;
  openDelay?: number;
};

export function DisabledReasonTooltip({
  label,
  disabled,
  children,
  openDelay = DISABLED_TOOLTIP_DELAY,
}: DisabledReasonTooltipProps) {
  return (
    <Tooltip
      label={label}
      disabled={disabled}
      position="top"
      w="auto"
      maw="200px"
      openDelay={openDelay}
    >
      <div>{children}</div>
    </Tooltip>
  );
}
